import React from 'react'
import DatePicker from 'react-datepicker'
import { Col } from 'reactstrap'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import './datestyle.css'

const UnignoreDate = props => {
  if (props.selectedValue && props.selectedValue.label === 'Ignored') {
    return (
      <div className="input-group" style={{ paddingTop: '5px', width: '100%' }}>
        <Col sm={2} style={{ alignSelf: 'center' }}>
          Until
        </Col>
        <Col sm={10} style={{ paddingRight: '0px' }}>
          <DatePicker
            style={{ width: '100%', paddingTop: '5px' }}
            className="form-control"
            dateFormat="dd/MM/yyyy"
            selected={props.selectedDate}
            onChange={props.handleDateChange}
          />
        </Col>
      </div>
    )
  } else {
    return null
  }
}

export default UnignoreDate
